var React = require('react');
import { phoneSettings, defaultSettings } from './master/settings'
class MasterInput extends React.Component {

    constructor(){
        super()
        this.onChange = this.onChange.bind(this)
        this.value = this.value.bind(this)
        this.typeSettings = this.typeSettings.bind(this)
    }

    onChange(e){
        this.props.actions.updateField(this.props.name, { value: this.formatter(e.target.value), is_touched: true })
    }

    formatter(value){
        return this.typeSettings().formatter(value);
    }

    typeSettings(){
        switch(this.props.type){
            case 'phone':
                return phoneSettings;
            default:
                return defaultSettings;
        }
    }

    isValid(){
        return this.props.store.fields[this.props.name].validator(this.value())
    }

    value(){
        return this.props.store.fields[this.props.name].value
    }

    isTouched(){
        return this.props.store.fields[this.props.name].is_touched
    }

    errorMessage(){
        if(!this.isValid() && this.isTouched()) {
            return (
                <div className={'error-message'}>
                    {this.props.store.fields[this.props.name].errorMessage}
                </div>
            )
        }
    }

    render() {
        return (
            <div className="w70 m-w100">
                {this.errorMessage()}
                <input className='form-input' id={this.props.name} maxLength={this.typeSettings().maxlength} name={this.props.name} type='text' onChange={this.onChange} value={this.value()} />
            </div>
        );
    }
}

export default MasterInput
